import { ref } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useWarehouseReportsList() {
    const toast = useToast()
    const records = ref([])
    const loading = ref(false)
    const totalRecords = ref(0)

    const fetchReport = async params => {
        loading.value = true

        try {
            const response = await store.dispatch('cromis-warehouse-reports/report', params)
            const payload = response.data
            const data = payload.data || payload.records || payload
            records.value = Array.isArray(data) ? data : []
            totalRecords.value = payload.meta ? (payload.meta.total || records.value.length) : records.value.length
        } catch (error) {
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error fetching report data',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        } finally {
            loading.value = false
        }
    }

    return {
        records,
        loading,
        totalRecords,
        fetchReport,
    }
}
